import React from "react";
import {
  Accordion,
  Button,
  Dropdown,
  Form,
  Tab,
  Tabs,
  ListGroup,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const Settings = () => {
  const { t } = useTranslation();
  return (
    <div className="formeditor-sidebar ms-auto sidebar-right bg-white global-tab h-100">
      <div className="p-3 h-100 d-flex flex-column">
        <Tabs
          defaultActiveKey="edit-filed"
          id="fill-tab-example"
          className="mb-3"
        >
          <Tab eventKey="edit-filed" title="Edit filed">
            <Accordion defaultActiveKey="2">
              <Accordion.Item eventKey="0">
                <Accordion.Header className="text-uppercase">
                  General Setting
                </Accordion.Header>
                <Accordion.Body>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Auto complete
                    </label>
                    <div className="d-flex">
                      <div className="col-2">
                        <Dropdown
                          className="d-grid edit-option"
                          autoClose="outside"
                        >
                          <Dropdown.Toggle
                            variant="gray-light border border-end-0 rounded-end-0"
                            id="dropdown-basic"
                          ></Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="py-0 px-3">
                              <Accordion
                                defaultActiveKey="0"
                                className="option-accordion relative"
                              >
                                <Accordion.Item
                                  eventKey="0"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    File: Instruction.pdf
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                  eventKey="1"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    File : Curriculum2023.pdf
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="col">
                        <Dropdown
                          className="d-grid gap-2 max-230"
                          autoClose="outside"
                          align={{ lg: "end" }}
                        >
                          <Dropdown.Toggle
                            variant="gray-light border rounded-start-0 plus-btn"
                            id="dropdown-basic"
                          >
                            Add Options
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="px-2">
                              <div className="d-grid gap-2">
                                <Dropdown
                                  className="d-grid gap-2 max-230"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="gray-light"
                                    id="dropdown-basic"
                                  >
                                    Import from database
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    {/* <div className="item py-2 px-3">Country API</div> */}
                                    <div className="item py-2 px-3">
                                      <Form.Select aria-label="Default select example">
                                        <option>Select APT</option>
                                        <option option value="1">
                                          XYZ API
                                        </option>
                                        <option value="2">ABC API</option>
                                        <option value="3">UFC API</option>
                                      </Form.Select>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                                <Dropdown
                                  className="d-grid gap-2 add-option"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="dark plus-btn"
                                    id="dropdown-basic"
                                  >
                                    Add manually
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <div className="py-2 px-3">
                                      <div className="mb-3">
                                        <div className="col">
                                          <Form.Label htmlFor="inputKey">
                                            Value
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            id="inputKey"
                                            aria-describedby="passwordHelpBlock"
                                          />
                                        </div>
                                      </div>
                                      <div className="gap-4">
                                        <Button variant="gray-light me-2">
                                          {t("common.button.cancel")}
                                        </Button>
                                        <Button variant="dark">Save</Button>
                                      </div>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Multi Grid Options
                    </label>

                    <Dropdown
                      className="d-grid gap-2 w-260"
                      autoClose="outside"
                      align={{ lg: "end" }}
                    >
                      <Dropdown.Toggle
                        variant="gray-light border down-btn"
                        id="dropdown-basic"
                      >
                        Add Column details
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="grid-option-dropdown">
                        <div className="px-3 pb-3">
                          <Accordion defaultActiveKey="0">
                            <Accordion.Item
                              eventKey="0"
                              className="position-relative"
                            >
                              <Button
                                variant="transparent small-btn position-absolute row-delete-btn"
                                size="sm"
                              >
                                <span className="material-symbols-outlined align-middle remove-btn">
                                  delete
                                </span>
                              </Button>
                              <Accordion.Header>
                                <Form.Group className="pe-5 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Row 1"
                                  />
                                </Form.Group>
                              </Accordion.Header>
                              <Accordion.Body className="pt-2 pb-0 px-0">
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 1"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 2"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 3"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Button variant="transparent px-0">
                                  <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                  Add more
                                </Button>
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                              eventKey="1"
                              className="position-relative"
                            >
                              <Button
                                variant="transparent small-btn position-absolute row-delete-btn"
                                size="sm"
                              >
                                <span className="material-symbols-outlined align-middle remove-btn">
                                  delete
                                </span>
                              </Button>
                              <Accordion.Header>
                                <Form.Group className="pe-5 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Row 2"
                                  />
                                </Form.Group>
                              </Accordion.Header>
                              <Accordion.Body className="pt-2 pb-0 px-0">
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 1"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 2"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 3"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Button variant="transparent px-0">
                                  <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                  Add more
                                </Button>
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                              eventKey="2"
                              className="position-relative"
                            >
                              <Button
                                variant="transparent small-btn position-absolute row-delete-btn"
                                size="sm"
                              >
                                <span className="material-symbols-outlined align-middle remove-btn">
                                  delete
                                </span>
                              </Button>
                              <Accordion.Header>
                                <Form.Group className="pe-5 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Row 3"
                                  />
                                </Form.Group>
                              </Accordion.Header>
                              <Accordion.Body className="pt-2 pb-0 px-0">
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 1"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 2"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Form.Group className="mb-2 d-flex">
                                  <Form.Control
                                    type="text"
                                    placeholder="Column 3"
                                  />
                                  <Button
                                    variant="transparent small-btn"
                                    size="sm"
                                  >
                                    <span className="material-symbols-outlined align-middle remove-btn">
                                      delete
                                    </span>
                                  </Button>
                                </Form.Group>
                                <Button variant="transparent px-0">
                                  <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                  Add more
                                </Button>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>

                          <hr className="my-1" />
                          <Button variant="transparent px-0">
                            <i className="bx bxs-plus-circle me-1 align-middle"></i>
                            Add more
                          </Button>

                          <div className="mt-2">
                            <Button variant="gray-light me-2">
                              {t("common.button.cancel")}
                            </Button>
                            <Button variant="dark">Save</Button>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Add Section Header Here
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="Add Text"
                    />
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Add Question Here
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="Add Text"
                    />
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Add Padding
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="Add Text"
                    />
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Field Name <small>(The filed should be unique)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="Candidate Name"
                    />
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Dropdown Options
                    </label>
                    <div className="d-flex">
                      <div className="col-2">
                        <Dropdown
                          className="d-grid edit-option"
                          autoClose="outside"
                        >
                          <Dropdown.Toggle
                            variant="gray-light border border-end-0 rounded-end-0"
                            id="dropdown-basic"
                          ></Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="py-0 px-3">
                              <Accordion
                                defaultActiveKey="0"
                                className="option-accordion relative"
                              >
                                <Accordion.Item
                                  eventKey="0"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    Value : Afganisthan
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                  eventKey="1"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    Value : Afganisthan
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                  eventKey="2"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    Value : Afganisthan
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                  eventKey="3"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    Value : Afganisthan
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="col">
                        <Dropdown
                          className="d-grid gap-2 w-260"
                          autoClose="outside"
                          align={{ lg: "end" }}
                        >
                          <Dropdown.Toggle
                            variant="gray-light border rounded-start-0 plus-btn"
                            id="dropdown-basic"
                          >
                            Add Options
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="py-2 px-3">
                              <div className="d-flex mb-3">
                                {/* <div className="col-2">
                                                                        <Form.Label htmlFor="inputNumber">
                                                                            &nbsp;
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            id="inputNumber"
                                                                            placeholder="1"
                                                                            aria-label="Disabled input example"
                                                                            disabled
                                                                            readOnly
                                                                            className="rounded-end-0 border-end-0"
                                                                        />
                                                                    </div> */}
                                <div className="col">
                                  <Form.Label htmlFor="inputValue">
                                    Value
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    id="inputValue"
                                    aria-describedby="passwordHelpBlock"
                                    className="rounded-end-0 border-end-0"
                                  />
                                </div>
                                <div className="col">
                                  <Form.Label htmlFor="inputKey">
                                    Key
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    id="inputKey"
                                    aria-describedby="passwordHelpBlock"
                                    className="rounded-0 border-end-0"
                                  />
                                </div>
                                <div className="col">
                                  <Form.Label htmlFor="parentKey">
                                    Parent
                                  </Form.Label>
                                  <Form.Select
                                    aria-label="Default select example"
                                    id="parentKey"
                                    className="rounded-start-0"
                                  >
                                    <option>Select</option>
                                    <option value="1">IN</option>
                                    <option value="2">US</option>
                                    <option value="3">EU</option>
                                  </Form.Select>
                                </div>
                              </div>
                              <div className="gap-4">
                                <Button variant="gray-light me-2">
                                  {t("common.button.cancel")}
                                </Button>
                                <Button variant="dark">Save</Button>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Upload File
                    </label>
                    <div className="d-flex">
                      <div className="col-2">
                        <Dropdown
                          className="d-grid edit-option"
                          autoClose="outside"
                        >
                          <Dropdown.Toggle
                            variant="gray-light border border-end-0 rounded-end-0"
                            id="dropdown-basic"
                          ></Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="py-0 px-3">
                              <Accordion
                                defaultActiveKey="0"
                                className="option-accordion relative"
                              >
                                <Accordion.Item
                                  eventKey="0"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    File: Instruction.pdf
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                  eventKey="1"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    File : Curriculum2023.pdf
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="col">
                        <Dropdown
                          className="d-grid gap-2 max-300"
                          autoClose="outside"
                          align={{ lg: "end" }}
                        >
                          <Dropdown.Toggle
                            variant="gray-light border rounded-start-0 plus-btn"
                            id="dropdown-basic"
                          >
                            Add Files
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="py-2 px-3">
                              <div className="d-flex flex-wrap">
                                <div className="col-12">
                                  <Form.Label htmlFor="filetype">
                                    File Type
                                  </Form.Label>
                                  <Form.Select
                                    aria-label="Default select example"
                                    id="filetype"
                                    className="rounded border-1"
                                  >
                                    <option>select</option>
                                    <option value="1">PDF</option>
                                    <option value="2">DOC</option>
                                    <option value="3">JPG</option>
                                  </Form.Select>
                                </div>

                                <div className="col-12">
                                  <Form.Group
                                    controlId="formFile"
                                    className="mb-3"
                                  >
                                    <Form.Label>
                                      Default file input example
                                    </Form.Label>
                                    <Form.Control type="file" className="" />
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="gap-4">
                                <Button variant="gray-light me-2">
                                  {t("common.button.cancel")}
                                </Button>
                                <Button variant="dark">Save</Button>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="placeholderText" className="form-label">
                      Placeholder text
                    </label>
                    <textarea
                      className="form-control"
                      id="placeholderText"
                      rows="3"
                      placeholder="Add Text"
                    ></textarea>
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="placeholderReason" className="form-label">
                      Reason for the filed
                    </label>
                    <textarea
                      className="form-control"
                      id="placeholderReason"
                      rows="3"
                      placeholder="Add Text"
                    ></textarea>
                  </div>
                  <div className="mb-3 input-sm">
                    <label className="form-label">Button Color</label>
                    <Dropdown className="d-grid gap-2">
                      <Dropdown.Toggle
                        variant="gray-light border arrow-btn"
                        id="dropdown-basic"
                      >
                        <div className="d-flex align-items-center">
                          <div className="color-code me-2">
                            <input
                              type="radio"
                              className="btn-check"
                              name="options"
                              id="option2"
                              autocomplete="off"
                            />
                            <label
                              className="btn btn-secondary rounded-1"
                              for="option2"
                            ></label>
                          </div>
                          <span>Orange #E57524</span>
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="w-full p-2">
                        <ul className="builder-color-list m-0 p-0">
                          <li className="d-flex align-items-center">
                            <div className="color-code me-2">
                              <input
                                type="radio"
                                className="btn-check"
                                name="options"
                                id="option1"
                                autocomplete="off"
                              />
                              <label
                                className="btn btn-primary rounded-1"
                                for="option1"
                              ></label>
                            </div>
                            <span>Blue #182A58</span>
                          </li>
                          <li className="d-flex align-items-center">
                            <div className="color-code me-2">
                              <input
                                type="radio"
                                className="btn-check"
                                name="options"
                                id="option2"
                                autocomplete="off"
                              />
                              <label
                                className="btn btn-secondary rounded-1"
                                for="option2"
                              ></label>
                            </div>
                            <span>Orange #E57524</span>
                          </li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="mb-3 input-sm">
                    <label className="form-label">Text Color</label>
                    <Dropdown className="d-grid gap-2">
                      <Dropdown.Toggle
                        variant="gray-light border arrow-btn"
                        id="dropdown-basic"
                      >
                        <div className="d-flex align-items-center">
                          <div className="color-code me-2">
                            <input
                              type="radio"
                              className="btn-check"
                              name="options"
                              id="option2"
                              autocomplete="off"
                            />
                            <label
                              className="btn btn-secondary rounded-1"
                              for="option2"
                            ></label>
                          </div>
                          <span>Orange #E57524</span>
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="w-full p-2">
                        <ul className="builder-color-list m-0 p-0">
                          <li className="d-flex align-items-center">
                            <div className="color-code me-2">
                              <input
                                type="radio"
                                className="btn-check"
                                name="options"
                                id="option1"
                                autocomplete="off"
                              />
                              <label
                                className="btn btn-primary rounded-1"
                                for="option1"
                              ></label>
                            </div>
                            <span>Blue #182A58</span>
                          </li>
                          <li className="d-flex align-items-center">
                            <div className="color-code me-2">
                              <input
                                type="radio"
                                className="btn-check"
                                name="options"
                                id="option2"
                                autocomplete="off"
                              />
                              <label
                                className="btn btn-secondary rounded-1"
                                for="option2"
                              ></label>
                            </div>
                            <span>Orange #E57524</span>
                          </li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="columnSpan" className="form-label">
                      Column Span
                    </label>
                    <select
                      className="form-select"
                      id="columnSpan"
                      aria-label="Default select example"
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                    </select>
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Checkbox Options
                    </label>
                    <div className="d-flex">
                      <div className="col-2">
                        <Dropdown
                          className="d-grid edit-option"
                          autoClose="outside"
                        >
                          <Dropdown.Toggle
                            variant="gray-light border border-end-0 rounded-end-0"
                            id="dropdown-basic"
                          ></Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="py-0 px-3">
                              <Accordion
                                defaultActiveKey="0"
                                className="option-accordion relative"
                              >
                                <Accordion.Item
                                  eventKey="0"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    File: Instruction.pdf
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                  eventKey="1"
                                  className="relative"
                                >
                                  <Accordion.Header>
                                    File : Curriculum2023.pdf
                                  </Accordion.Header>
                                  <div className="edit-dlt-btn">
                                    <Button variant="transparent">
                                      <i className="bx bx-pencil"></i>
                                    </Button>
                                    <Button variant="transparent">
                                      <i className="bx bx-trash-alt"></i>
                                    </Button>
                                  </div>
                                  <Accordion.Body className="pb-0">
                                    <ul className="m-0 p-0">
                                      <li>
                                        <strong>Value :</strong> Antigua and
                                        barbua
                                      </li>
                                      <li>
                                        <strong>Key :</strong> ANBR
                                      </li>
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="col">
                        <Dropdown
                          className="d-grid gap-2 max-230"
                          autoClose="outside"
                          align={{ lg: "end" }}
                        >
                          <Dropdown.Toggle
                            variant="gray-light border rounded-start-0 plus-btn"
                            id="dropdown-basic"
                          >
                            Add Options
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="px-2">
                              <div className="d-grid gap-2">
                                <Dropdown
                                  className="d-grid gap-2 max-230"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="gray-light"
                                    id="dropdown-basic"
                                  >
                                    Import from database
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    {/* <div className="item py-2 px-3">Country API</div> */}
                                    <div className="item py-2 px-3">
                                      <Form.Select aria-label="Default select example">
                                        <option>Select APT</option>
                                        <option option value="1">
                                          XYZ API
                                        </option>
                                        <option value="2">ABC API</option>
                                        <option value="3">UFC API</option>
                                      </Form.Select>
                                    </div>
                                    {/* <div className="search-div mb-3">
                                                                                <InputGroup className="mb-3">
                                                                                    <InputGroup.Text id="basic-addon1"><i className="pluto-search"></i></InputGroup.Text>
                                                                                    <Form.Control
                                                                                        placeholder="Search option"
                                                                                        aria-label="Username"
                                                                                        aria-describedby="basic-addon1"
                                                                                    />
                                                                                </InputGroup>
                                                                            </div> */}
                                    {/* <ListGroup className=" py-2 px-3">
                                                                                <ListGroup.Item>XYZ API</ListGroup.Item>
                                                                                <ListGroup.Item>ABC API</ListGroup.Item>
                                                                                <ListGroup.Item>UFC API</ListGroup.Item>
                                                                            </ListGroup> */}
                                  </Dropdown.Menu>
                                </Dropdown>
                                {/* <Button variant="dark btn-sm">Add manually</Button> */}
                                <Dropdown
                                  className="d-grid gap-2 add-option"
                                  autoClose="outside"
                                  align={{ lg: "end" }}
                                >
                                  <Dropdown.Toggle
                                    variant="dark plus-btn"
                                    id="dropdown-basic"
                                  >
                                    Add manually
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <div className="py-2 px-3">
                                      <div className="d-flex mb-3">
                                        <div className="col">
                                          <Form.Label htmlFor="inputValue">
                                            Key
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            id="inputValue"
                                            aria-describedby="passwordHelpBlock"
                                            className="rounded-end-0 border-end-0"
                                          />
                                        </div>
                                        <div className="col">
                                          <Form.Label htmlFor="inputKey">
                                            Value
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            id="inputKey"
                                            aria-describedby="passwordHelpBlock"
                                            className="rounded-0 border-end-0"
                                          />
                                        </div>
                                        {/* <div className="col">
                                                                                        <Form.Label htmlFor="parentKey">
                                                                                            Parent
                                                                                        </Form.Label>
                                                                                        <Form.Select aria-label="Default select example" id="parentKey" className="rounded-0">
                                                                                            <option>Select</option>
                                                                                            <option value="1">IN</option>
                                                                                            <option value="2">US</option>
                                                                                            <option value="3">EU</option>
                                                                                        </Form.Select>
                                                                                    </div> */}
                                        <div className="col-2">
                                          <Form.Label htmlFor="parentKey">
                                            Parent
                                          </Form.Label>
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="light btn-xs rounded-start-0 w-100 border-bottom-0"
                                              id="dropdown-basic"
                                            ></Dropdown.Toggle>

                                            <Dropdown.Menu className="p-3">
                                              <div className="select-group">
                                                <div className="selected-options">
                                                  <input
                                                    className="search-input"
                                                    placeholder="Search"
                                                    type="text"
                                                  />
                                                </div>
                                                <ListGroup className="select-dropdown">
                                                  <ListGroup.Item>
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                      />
                                                      Select All
                                                    </label>
                                                  </ListGroup.Item>
                                                  <ListGroup.Item>
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                      />
                                                      Deutschland
                                                    </label>
                                                  </ListGroup.Item>
                                                  <ListGroup.Item>
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                      />
                                                      Indian
                                                    </label>
                                                  </ListGroup.Item>
                                                  <ListGroup.Item>
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                      />
                                                      Pakistani
                                                    </label>
                                                  </ListGroup.Item>
                                                  <ListGroup.Item>
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                      />
                                                      Jordan
                                                    </label>
                                                  </ListGroup.Item>
                                                </ListGroup>
                                              </div>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </div>
                                      <div className="gap-4">
                                        <Button variant="gray-light me-2">
                                          {t("common.button.cancel")}
                                        </Button>
                                        <Button variant="dark">Save</Button>
                                      </div>
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="parent-filed">
                        Dependent on Parent filed
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="parent-filed"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="file-type">
                        Allowed File Type
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="file-type"
                      />
                    </div>

                    <Form>
                      {["checkbox"].map((type) => (
                        <div key={`file-type-${type}`} className="mb-3">
                          <Form.Check
                            label="JPG"
                            name="group1"
                            type={type}
                            id={`file-type-${type}-jpg`}
                          />
                          <Form.Check
                            label="PNG"
                            name="group1"
                            type={type}
                            id={`file-type-${type}-png`}
                          />
                          <Form.Check
                            label="PDF"
                            name="group1"
                            type={type}
                            id={`file-type-${type}-pdf`}
                          />
                          <Form.Check
                            label="DOX"
                            name="group1"
                            type={type}
                            id={`file-type-${type}-dox`}
                          />
                        </div>
                      ))}
                    </Form>
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Add image caption
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="Add Text"
                    />
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Field Name <small>(The filed should be unique)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="Personality Trait"
                    />
                  </div>
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Upload image
                    </label>
                    <div className="mb-3 file-input-box bg-white px-3 py-2 border rounded cursor-pointer">
                      <label
                        for="file"
                        className="d-block text-center d-flex align-items-center cursor-pointer"
                      >
                        <span className="mb-0 text-sm text-primary">
                          testimage.jpg
                        </span>
                        <span className="material-symbols-outlined ms-auto text-lg">
                          upload
                        </span>
                      </label>
                      <input type="file" id="file" className="d-none" />
                    </div>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Add Video Link
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="www.youtube.com/video"
                    />
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      rows={6}
                      className="form-control"
                      id="description"
                      placeholder="Welcome to the EdTech UX Survey!"
                    ></textarea>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="columnSpan" className="form-label">
                      Choose Parent field
                    </label>
                    <select
                      className="form-select"
                      id="columnSpan"
                      aria-label="Default select example"
                    >
                      <option value="1">Country</option>
                      <option value="2">India</option>
                      <option value="3">UAE</option>
                    </select>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Required Field
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Hidden Field
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Internal Field
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Validate Field</Accordion.Header>
                <Accordion.Body>
                  <div className="input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Field Length
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="row">
                      <div className="col">
                        <label for="fieldType" className="form-label">
                          Min character
                        </label>
                        <select
                          className="form-select"
                          id="fieldType"
                          aria-label="Default select example"
                        >
                          <option>select</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                      <div className="col">
                        <label for="fieldType" className="form-label">
                          Max character
                        </label>
                        <select
                          className="form-select"
                          id="fieldType"
                          aria-label="Default select example"
                        >
                          <option>select</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Character Type
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    {/* <label for="fieldType" className="form-label">Min character</label> */}
                    <select
                      className="form-select"
                      id="fieldType"
                      aria-label="Default select example"
                    >
                      <option>Alphabet</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="40">40</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <label for="fieldName" className="form-label">
                      Field Pattern
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fieldName"
                      placeholder="ABC-DEF-GHI-JK"
                    />
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Numeric Type
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <Form>
                      {["checkbox"].map((type) => (
                        <div key={`reverse-${type}`} className="mb-3">
                          <Form.Check
                            label="Integer Value"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-1`}
                          />
                          <Form.Check
                            label="Decimal Value"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-2`}
                          />
                        </div>
                      ))}
                    </Form>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Measurment Unit
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <Form.Select aria-label="Default select example">
                      <option>Persentage</option>
                      <option value="1">Standerd</option>
                      <option value="2">MAAC</option>
                      <option value="3">Three</option>
                    </Form.Select>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Navigation Number
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Default Value
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <Form.Select aria-label="Default select example">
                      <option>Select Value</option>
                      <option value="1">Value 1</option>
                      <option value="2">Value 2</option>
                      <option value="3">Value 3</option>
                    </Form.Select>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Others Options
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Conditional
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Allowed Years
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="row">
                      <div className="col">
                        <label for="fieldType" className="form-label">
                          Current +
                        </label>
                        <select
                          className="form-select"
                          id="fieldType"
                          aria-label="Default select example"
                        >
                          <option>select</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                      <div className="col">
                        <label for="fieldType" className="form-label">
                          Current -
                        </label>
                        <select
                          className="form-select"
                          id="fieldType"
                          aria-label="Default select example"
                        >
                          <option>select</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Disable Date Past
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    {/* <div className="input-group mb-3">
                          <input type="date" className="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2"/>
                          <span className="input-group-text" id="basic-addon2"><span className="material-symbols-outlined">calendar_month</span></span>
                        </div> */}
                    <input
                      type="date"
                      className="form-control"
                      id="fieldName"
                      placeholder="Choose date"
                    />
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Disable Time Frame
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="row">
                      <div className="col">
                        <label for="fieldType" className="form-label">
                          Start form
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          id="fieldName"
                          placeholder="Choose date"
                        />
                      </div>
                      <div className="col">
                        <label for="fieldType" className="form-label">
                          End at
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          id="fieldName"
                          placeholder="Choose date"
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Date Format
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <Form.Select aria-label="Default select example">
                      <option>DD/MM/YY</option>
                      <option value="1">MM/DD/YY</option>
                      <option value="2">YY/DD/MM</option>
                      <option value="3">YY/MM/DD</option>
                    </Form.Select>
                  </div>
                  <hr />
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label
                        className="form-check-label"
                        for="flexSwitchCheckDefault"
                      >
                        Time Format
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <Form.Select aria-label="Default select example">
                      <option>12 hr</option>
                      <option value="1">24 hr</option>
                    </Form.Select>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Field</Accordion.Header>
                <Accordion.Body>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="FiledLength">
                        Filed Length
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="FiledLength"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="CharacterType">
                        Character Type
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="CharacterType"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="FieldMapping">
                        Field Mapping
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="FieldMapping"
                      />
                    </div>
                  </div>
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="FieldPattern">
                        Field Pattern
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="FieldPattern"
                      />
                    </div>
                  </div>
                  <div className="mb-3 border rounded-3">
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item
                        eventKey="0"
                        className="bg-transparent border-bottom"
                      >
                        <Accordion.Header className="px-2">
                          Map filed
                        </Accordion.Header>
                        <Accordion.Body className="px-2">
                          <div className="mb-3">
                            <div className="mb-3 input-sm switch-row position-relative">
                              <div className="row">
                                <div className="col">
                                  <label for="fieldType" className="form-label">
                                    Map filed
                                  </label>
                                  <select
                                    className="form-select"
                                    id="fieldType"
                                    aria-label="Default select example"
                                  >
                                    <option>Value 1</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                  </select>
                                </div>
                                <div className="col">
                                  <label
                                    for="fieldType"
                                    className="form-label text-orange-900"
                                  >
                                    To Data Source
                                  </label>
                                  <select
                                    className="form-select"
                                    id="fieldType"
                                    aria-label="Default select example"
                                  >
                                    <option>Multi select</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="text-end btn-small">
                              <Button variant="light" size="sm">
                                Cancel
                              </Button>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1" className="bg-transparent">
                        <Accordion.Header className="px-2">
                          Calculate field
                        </Accordion.Header>
                        <Accordion.Body className="px-2">
                          <div className="mb-3 input-sm">
                            <label for="CalculateFiled" className="form-label">
                              Calculate filed
                            </label>
                            <select
                              className="form-select"
                              id="CalculateFiled"
                              aria-label="Default select example"
                            >
                              <option>Date calculation</option>
                              <option>Numeric calculation</option>
                            </select>
                          </div>
                          <div className="mb-3 input-sm">
                            <label
                              for="CalculateFiled"
                              className="form-label text-orange-900"
                            >
                              Define equation
                            </label>
                            <div className="border rounded-3">
                              <div className="p-2">
                                <div className="row g-0">
                                  <div className="col-5">
                                    <span
                                      type="button"
                                      className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-2 position-relative text-wrap text-start"
                                    >
                                      fieldID: submission_date
                                      <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle">
                                        <i className="bx bx-x"></i>
                                      </span>
                                    </span>
                                    <span
                                      type="button"
                                      className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-2 position-relative text-wrap text-start"
                                    >
                                      fieldID:type2fieldname
                                      <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle">
                                        <i className="bx bx-x"></i>
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-2 btn-small text-center">
                                    <Button
                                      variant="light"
                                      size="sm"
                                      className="px-2"
                                    >
                                      <i className="bx bx-plus"></i>
                                    </Button>
                                  </div>
                                  <div className="col-5">
                                    <span
                                      type="button"
                                      className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-2 position-relative text-wrap text-start"
                                    >
                                      fieldID:dateofbirth
                                      <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle">
                                        <i className="bx bx-x"></i>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="bg-light p-2">
                                <div className="row g-2">
                                  <div className="col">
                                    <select
                                      className="form-select"
                                      id="fieldType"
                                      aria-label="Default select example"
                                    >
                                      <option>Select field</option>
                                      <option value="20">20</option>
                                      <option value="30">30</option>
                                      <option value="40">40</option>
                                      <option value="50">50</option>
                                    </select>
                                  </div>
                                  <div className="col">
                                    <select
                                      className="form-select"
                                      id="fieldType"
                                      aria-label="Default select example"
                                    >
                                      <option>Operators</option>
                                      <option value="20">20</option>
                                      <option value="30">30</option>
                                      <option value="40">40</option>
                                      <option value="50">50</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="text-end btn-small">
                            <Button variant="light" size="sm">
                              Cancel
                            </Button>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>

                  <hr />

                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="FieldPattern">
                        Calculate filed
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="FieldPattern"
                      />
                    </div>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="CalculateFiled" className="form-label">
                      Calculate filed
                    </label>
                    <select
                      className="form-select"
                      id="CalculateFiled"
                      aria-label="Default select example"
                    >
                      <option>Date calculation</option>
                      <option>Time calculation</option>
                    </select>
                  </div>
                  <div className="mb-3 input-sm">
                    <label
                      for="CalculateFiled"
                      className="form-label text-orange-900"
                    >
                      Define equation
                    </label>
                    <div className="mb-3 border rounded-3">
                      <div className="p-2 define-box">
                        <div className="row justify-content-between g-0 position-relative">
                          <div className="col-5">
                            <span
                              type="button"
                              className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-1 position-relative text-wrap text-start w-100"
                            >
                              fieldID:submission_date
                              <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle"></span>
                            </span>
                          </div>
                          <div className="col-5">
                            <span
                              type="button"
                              className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-1 position-relative text-wrap text-start w-100"
                            >
                              fieldID:dateofbirth
                              <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle"></span>
                            </span>
                          </div>
                          <div className="position-absolute btn-small text-center calculator-position">
                            <Button
                              variant="light"
                              size="sm"
                              className="px-2 py-0"
                            >
                              <i className="bx bx-minus"></i>
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="bg-light p-2">
                        <div className="row g-2">
                          <div className="col">
                            <select
                              className="form-select"
                              id="fieldType"
                              aria-label="Default select example"
                            >
                              <option>Add field</option>
                              <option value="20">20</option>
                              <option value="30">30</option>
                              <option value="40">40</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="calculator">
                        <div className="calculator__keys">
                          <button className="calculator__key">1</button>
                          <button className="calculator__key">2</button>
                          <button className="calculator__key">3</button>
                          <button className="calculator__key">4</button>
                          <button className="calculator__key">5</button>
                          <button className="calculator__key">6</button>
                          <button className="calculator__key">7</button>
                          <button className="calculator__key">8</button>
                          <button className="calculator__key">9</button>
                          <button className="calculator__key">0</button>
                          <button className="calculator__key">.</button>
                          <button className="calculator__key">(</button>
                          <button className="calculator__key">)</button>
                          <button className="calculator__key calculator__key--operator">
                            +
                          </button>
                          <button className="calculator__key calculator__key--operator">
                            -
                          </button>
                          <button className="calculator__key calculator__key--operator">
                            &times;
                          </button>
                          <button className="calculator__key calculator__key--operator">
                            ÷
                          </button>
                          <button className="calculator__key">AC</button>
                          <button className="calculator__key calculator__key--enter">
                            =
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label
                        for="CalculateFiled"
                        className="form-label text-orange-900"
                      >
                        Expect result in
                      </label>

                      <select
                        className="form-select"
                        id="CalculateFiled"
                        aria-label="Default select example"
                      >
                        <option>Date</option>
                        <option selected>Month</option>
                        <option>Year</option>
                      </select>
                    </div>

                    <div className="text-end btn-small">
                      <button
                        type="button"
                        className="btn btn-transparent btn-sm me-2"
                      >
                        Cancel
                      </button>
                      <button type="button" className="btn btn-dark btn-sm">
                        Save
                      </button>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Tab>
          <Tab eventKey="logic" title="Logic">
            <div className="email-form form-body pe-1">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="parent-filed">
                        Dependent on Parent filed
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="parent-filed"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="file-type">
                        Allowed File Type
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="file-type"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="mb-3 input-sm">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="mb-3 input-sm">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="mb-3 input-sm">
                    <label className="form-label">Choose Project</label>
                    <select className="form-select">
                      <option>Select</option>
                      <option>Cybersecurity and Dependability</option>
                      <option>Systems (Computer Science)</option>
                      <option>Methodology Development in Bioinformatics</option>
                      <option>
                        Mathematical Foundations of Data Science-Approve
                      </option>
                      <option>System Testing-Deny</option>
                      <option>
                        Mathematical Foundations of Data Science for 2021-2022
                        for XYZ Labs Super Computing
                      </option>
                      <option>Cybersecurity and Dependability-Deny</option>
                      <option>Systems (Computer Science)-Deny</option>
                      <option>
                        Mathematical Foundations of Data Science-Final Deny
                      </option>
                      <option>Cybersecurity Test</option>
                      <option>
                        Faculty positions in Computer Science-Deny
                      </option>
                      <option>Systems (Computer Science)-Approve</option>
                      <option>Systems (Computer Science)-Final Deny</option>
                      <option>
                        Methodology Development in Bioinformatics-Deny
                      </option>
                      <option>
                        Methodology Development in Bioinformatics-Final Deny
                      </option>
                      <option>
                        Mathematical Foundations of Data Science-Deny
                      </option>
                      <option>
                        Cybersecurity and Dependability-Final Deny
                      </option>
                      <option>Cybersecurity and Dependability-Approve</option>
                      <option>
                        Methodology Development in Bioinformatics-Approve
                      </option>
                      <option>
                        Faculty positions in Computer Science-Approve
                      </option>
                      <option>
                        Faculty positions in Computer Science-Final Deny
                      </option>
                      <option>Cybersecurity</option>
                      <option>Cybersecurity Testing</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                      <label className="form-check-label" for="parent-filed">
                        Enable
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="parent-filed"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="if-wrapper">
                <div className="step-row mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <label>If</label>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                      <div className="mb-3">
                        <select className="form-select">
                          <option value="">All</option>
                          <option value="">Any</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-5 col-sm-6 col-12">
                      <div className="mb-3">
                        <strong className="small">
                          of the following is true
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div className="add-row-wrapper">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3">
                          <select className="form-select">
                            <option value="">Select</option>
                            <option value="1">name</option>
                            <option value="2">Citizenship</option>
                            <option value="3">PhD Institution</option>
                            <option value="5">Institution granting PhD</option>
                            <option value="4">PhD Year</option>
                            <option value="6">Application Date</option>
                            <option value="7">Assignee</option>
                            <option value="90">Ranking</option>
                            <option value="8">Status</option>
                            <option value="9">Publications Profile URL</option>
                            <option value="10">Current Affiliation</option>
                            <option value="17">Rating</option>
                            <option value="18">LinkedIn Profile URL</option>
                            <option value="14">References</option>
                            <option value="15">Title of PhD</option>
                            <option value="16">Last5yearsh-index</option>
                            <option value="17">Last5yearsCitations</option>
                            <option value="18">i10-index</option>
                            <option value="20">Citations</option>
                            <option value="21">h-index</option>
                            <option value="24">
                              Number of supervised or co-supervised PhD students
                              (ongoing)
                            </option>
                            <option value="13">Comments</option>
                            <option value="22">Subject Area of PhD</option>
                            <option value="25">
                              Primary Area of Expertise
                            </option>
                            <option value="23">
                              Number of supervised or co-supervised PhD students
                              (graduated)
                            </option>
                            <option value="26">Last5yearsi10-index</option>
                            <option value="27">LastDateSent</option>
                            <option value="36">Tag</option>
                            <option value="37">Files</option>
                            <option value="39">Due Date</option>
                            <option value="35">Image</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3">
                          <select className="form-select">
                            <option>Select</option>
                            <option value="equals">equals</option>
                            <option value="not equals">not equals</option>
                            <option value="in this list">in this list</option>
                            <option value="not in this list">
                              not in this list
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Text here"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-5 col-sm-6 col-12">
                        <div className="d-flex column-gap-2">
                          <button type="button" className="delete-btn">
                            <i className="bx bx-plus"></i>
                          </button>
                          <button type="button" className="delete-btn">
                            <i className="bx bx-x"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bachcolor-color">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                  >
                    And/Or <i className="bx bx-plus bx-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>

        <div className="mt-3 d-grid gap-2">
          <Button variant="dark">
            <i className="bx bx-save bx-sm align-middle"></i> Save in Database
          </Button>
          <Button variant="gray-light">
            <i className="bx bx-globe bx-sm align-middle"></i> Save as Global
            Field
          </Button>
        </div>
      </div>
    </div>
  );
};
